import {HttpAxiosRequest} from 'src/http/httpAxiosBase'
import {EntityWithIdAndDescription, Moneda, SectorComercial, UnidadNegocio} from 'src/types'
import {OperacionContraparteImporteVista, OperacionCorporateImporteVista} from '../types/importes'
import {
    OperacionCLFBAgregadosVista,
    OperacionCLFBConcentracionesVista,
    OperacionCLFBHoldingPeriodsVista,
    OperacionCLFBLimitesVista
} from "../types/clfb";
import {OperacionNotaEstructuradaLimiteVista} from "../sistemas/nota_estructurada/types/types";
import {OperacionLEPTitulo, OperacionLEPUnidadNegocio, schemaOperacionLEPTituloList} from "../sistemas/lep/types/dto";
import {OperacionLCLSLimiteTipo, OperacionLCLSRelacion, OperacionLCSLSSectorComercial, OperacionLCSLSUnidadNegocio} from "../sistemas/lcls/types/dto";
import { OperacionLCTCClienteSubTipo, OperacionLCTCClienteTipo, OperacionLCTCRelacion, OperacionLCTCSectorComercial, OperacionLCTCUnidadNegocio } from '../sistemas/lctc/types/dto';
import { Http } from '@mui/icons-material';
import { OperacionAFOSectorComercial, OperacionAFOUnidadNegocio } from '../sistemas/afopu/types/dto';
import { EntidadCache } from '../types/types';
import { OperacionLCLSHPTILimiteTipo } from '../sistemas/lcslhpti/types/dto';

const getEndpoint = (url = '') => `cache/operaciones${url}`

export const HttpCacheOperacion = {
    getSectoresComercialesPorPaisyTipoMensaje: (codPais: number, codTipoMensaje: number): Promise<SectorComercial[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/${codPais}/${codTipoMensaje}/sectores-comerciales`))
    },

    getSectoresComercialesPorSistema: (codSistema: number): Promise<SectorComercial[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/${codSistema}/sectores-comerciales`))
    },

    getSectoresComercialesPorPaisSistemaGrupo: (codPais: number, codSistema: number): Promise<SectorComercial[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/${codPais}/${codSistema}/sector-comercial-grupos`))
    },

    // el grupo lo filtra el backend
    getUnidadesNegocioPorPaisYSistema: (codPais:number, codSistema: number): Promise<UnidadNegocio[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/${codPais}/${codSistema}/unidad-negocio-tipos`))
    },

    getSectoresComercialesPorUnidadNegocio: (codUnidadNegocio: number, codSistema: number): Promise<SectorComercial[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/${codUnidadNegocio}/${codSistema}/sector-comercial-tipos`))
    },


    getImportesPorMoneda: (codMoneda: number): Promise<OperacionContraparteImporteVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/contrapartes/${codMoneda}/importes`))
    },

    getImportesCorporatePorMoneda: (codMoneda: number): Promise<OperacionCorporateImporteVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/corporate/${codMoneda}/importes`))
    },

    getLimiteTipos: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint('/wrm/limite-tipos'))
    },

    getAforoTipos: (): Promise<OperacionContraparteImporteVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/clg/${1}/aforos`))
    },

    getActivoTipos: (codPais: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/clfb/${codPais}/tipos-activos`))
    },

    getAgregados: (codPais: number) : Promise<OperacionCLFBAgregadosVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/clfb/${codPais}/agregados`))
    },

    getConcentraciones: (codPais: number) : Promise<OperacionCLFBConcentracionesVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/clfb/${codPais}/concentraciones`))
    },

    getHoldingPeriods: (codPais: number) : Promise<OperacionCLFBHoldingPeriodsVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/clfb/${codPais}/periodos`))
    },

    getLimitesAbsolutos: (codPais: number) : Promise<OperacionCLFBLimitesVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/clfb/${codPais}/limites-absolutos`))
    },

    getLimitesNetos: (codPais: number) : Promise<OperacionCLFBLimitesVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/clfb/${codPais}/limites-netos`))
    },

    getLimitesConcertacionNotaEstructurada: (codPais: number) : Promise<OperacionNotaEstructuradaLimiteVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/nota-estructurada/${codPais}/limites-concertacion`))
    },

    getLimitesDVPNotaEstructurada: (codPais: number) : Promise<OperacionNotaEstructuradaLimiteVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/nota-estructurada/${codPais}/limites-dvp`))
    },

    getLimitesFOPNotaEstructurada: (codPais: number) : Promise<OperacionNotaEstructuradaLimiteVista[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/nota-estructurada/${codPais}/limites-fop`))
    },


    getCapitalMarketsTransaccionTipos: (codPais: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/capital-markets/${codPais}/transaccion-tipos`))
    },

    getCapitalMarketsAmortizacionTipos: (codPais: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/capital-markets/${codPais}/armortizacion-tipos`))
    },

    getCapitalMarketsRatingTipos: (codPais: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/capital-markets/${codPais}/rating-tipos`))
    },

    getCapitalMarketsDestinoFondoTipos: (codPais: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/capital-markets/${codPais}/destino-tipos`))
    },

    getCapitalMarketsSuperaLimitesUnderwritingTipos: (codPais: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/capital-markets/${codPais}/supera-limites-underwriting-tipos`))
    },

    getTransferenciaTercerosTipos: (codPais: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/transferencia-terceros/${codPais}/operacion-tipos`))
    },

    getTransferenciaTercerosMonedas: (codTipoOperacion: number) : Promise<Moneda[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/transferencia-terceros/${codTipoOperacion}/moneda-tipos`))
    },

    getControlOperativoControlTipos: (codPais: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/control-operativo/${codPais}/control-tipos`))
    },

    getControlOperativoSociedadTipos: (codPais: number) : Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/control-operativo/${codPais}/sociedad-tipos`))
    },

    getLEPEmisorTipos: (codSistema:number): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lep/${codSistema}/emisor-tipos`))
    },

    getLEPEmisorLimiteTipos: (codEmisor:number): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lep/${codEmisor}/emisor-limites`))
    },

    getLEPTitulos: (codSistema: number): Promise<OperacionLEPTitulo[]> => {
        const endpoint = getEndpoint(`/lep/${codSistema}/emisor-titulo`);

        return HttpAxiosRequest.get(endpoint)
            .then(response => {
                const parsed = schemaOperacionLEPTituloList.safeParse(response);

                if (!parsed.success) {
                    return Promise.reject(new Error('Validation error.'));
                }

                return parsed.data;
            })
            .catch(error => {
                return Promise.reject(new Error('Network error.'));
            });
    },

    getLEPTituloInicial: (codSistema: number): Promise<OperacionLEPTitulo[]> => {
        const endpoint = getEndpoint(`/lep/${codSistema}/emisor-titulo/inicial`);

        return HttpAxiosRequest.get(endpoint)
            .then(response => {
                const parsed = schemaOperacionLEPTituloList.safeParse(response);

                if (!parsed.success) {
                    return Promise.reject(new Error('Validation error.'));
                }

                return parsed.data;
            })
            .catch(error => {
                return Promise.reject(new Error('Network error.'));
            });
    },

    getLCLSLimiteTipos: (): Promise<OperacionLCLSLimiteTipo[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcls/limite-tipos`))
    },

    getLCLSClienteSubTipos: (codPais:number): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcls/${codPais}/cliente-sub-tipos`))
    },

    getLCLSClienteTipos: (codPais:number): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcls/${codPais}/cliente-tipos`))
    },

    getLCLSUnidadNegocioTipos: (codPais:number,codSistema:number): Promise<OperacionLCSLSUnidadNegocio[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcls/${codPais}/${codSistema}/unidad-negocio-tipos`))
    },

    getLCLSSectorComercialTipos: (codUnidadNegocio:number,codSistema:number): Promise<OperacionLCSLSSectorComercial[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcls/${codUnidadNegocio}/${codSistema}/sector-comercial-tipos`))
    },

    getLCLSRelacionTipos: (codSectorComercial:number): Promise<OperacionLCLSRelacion[]> =>  {
        return HttpAxiosRequest.get(getEndpoint(`/lcls/${codSectorComercial}/relaciones`))
    },

    getLCTCLimiteTipos: (): Promise<OperacionLCLSLimiteTipo[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lctc/limite-tipos`))
    },

    getLCTCClienteSubTipos: (codClienteTipo:number): Promise<OperacionLCTCClienteSubTipo[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lctc/${codClienteTipo}/cliente-sub-tipos`))
    },

    getLCTCClienteTipos: (codSectorComercial:number): Promise<OperacionLCTCClienteTipo[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lctc/${codSectorComercial}/cliente-tipos`))
    },

    getLCTCUnidadNegocioTipos: (codPais:number,codSistema:number): Promise<OperacionLCTCUnidadNegocio[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lctc/${codPais}/${codSistema}/unidad-negocio-tipos`))
    },

    getLCTCSectorComercialTipos: (codUnidadNegocio:number,codSistema:number): Promise<OperacionLCTCSectorComercial[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lctc/${codUnidadNegocio}/${codSistema}/sector-comercial-tipos`))
    },

    getLCTCRelacionTipos: (codSectorComercial:number): Promise<OperacionLCTCRelacion[]> =>  {
        return HttpAxiosRequest.get(getEndpoint(`/lctc/${codSectorComercial}/relaciones`))
    },
    
    getAFOPUAforoTipos: (codPais:number): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/afopu/${codPais}/aforo-tipos`))
    },

    getLCSLHPTILimiteTipos: (): Promise<OperacionLCLSHPTILimiteTipo[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcslhpti/limite-tipos`))
    },

    getLCSLHPTILimiteAgregadoTipos: (): Promise<OperacionLCLSHPTILimiteTipo[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcslhpti/limite-agregado-tipos`))
    },

    getLCSLHPTILimiteHoldingTipos: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcslhpti/limite-holding-tipos`))
    },

    getLCSLHPTIConcentracionTipos: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcslhpti/concentracion-tipos`))
    },

    getLCSLHPTILimitePerdidaTipos: (): Promise<EntityWithIdAndDescription[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/lcslhpti/limite-perdida-tipos`))
    },

    getADCMClienteTipos: (codPais:number): Promise<EntidadCache[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/adcm/${codPais}/cliente-tipos`))
    },

    getADCMEmisorTipos: (codPais:number): Promise<EntidadCache[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/adcm/${codPais}/emisor-tipos`))
    },

    getADCMTransaccionTipos: (codPais:number): Promise<EntidadCache[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/adcm/${codPais}/transaccion-tipos`))
    },

    getADLClienteTipos: (codPais:number): Promise<EntidadCache[]> => {

        return HttpAxiosRequest.get(getEndpoint(`/adl/${codPais}/cliente-tipos`))
    },

    getADLLegislacionTipos: (codPais:number): Promise<EntidadCache[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/adl/${codPais}/legislacion-tipos`))
    },
    
    getNOTESNotaTipos: (codPais:number): Promise<EntidadCache[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/notes/${codPais}/nota-tipos`))
    },

    getCFClienteTIpos: (codPais:number): Promise<EntidadCache[]> => {
        return HttpAxiosRequest.get(getEndpoint(`/cf/cliente-tipos`))
    },
}
